import { useState } from "react";
import { useStore } from "../store/Store";

export default function AdminLoginPage({ onNav }) {
  const { signInAdmin } = useStore();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const login = async () => {
    const signedIn = await signInAdmin(email.trim(), pass);
    if (signedIn) onNav("admin");
  };

  return (
    <div style={{ minHeight:"100vh", background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"white", borderRadius:24, padding:"clamp(28px,5vw,48px)", maxWidth:400, width:"100%", boxShadow:"0 20px 80px rgba(0,0,0,0.3)" }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontFamily:"'Noto Serif Devanagari','Playfair Display',serif", fontSize:28, fontWeight:900, color:"#1a1a2e" }}>मॅचवेल</div>
          <div style={{ fontSize:10, letterSpacing:3, textTransform:"uppercase", color:"#EC4899", marginTop:4, fontWeight:700 }}>Admin Panel</div>
        </div>
        <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Email</label>
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@email.com" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:14, background:"#fafafa" }}/>
        <label style={{ fontSize:9, letterSpacing:1, textTransform:"uppercase", color:"#999", display:"block", marginBottom:5, fontWeight:700 }}>Password</label>
        <input type="password" value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" style={{ width:"100%", padding:"11px 16px", border:"1px solid #e5e5e5", borderRadius:12, fontSize:13, outline:"none", marginBottom:22, background:"#fafafa" }} onKeyDown={e=>e.key==="Enter"&&login()}/>
        <button type="button" onClick={login} style={{ width:"100%", padding:"14px", background:"linear-gradient(135deg,#EC4899,#7C3AED)", color:"white", border:"none", borderRadius:50, fontSize:14, fontWeight:800, cursor:"pointer", marginBottom:14 }}>
          Login to Admin
        </button>
        <div style={{ textAlign:"center" }}>
          <span onClick={()=>onNav("home")} style={{ fontSize:12, color:"#999", cursor:"pointer" }}>← Back to Website</span>
        </div>
      </div>
    </div>
  );
}
